import debounce from "lodash/debounce";
import { useState, useEffect } from "react";

/**
 * @method
 * @returns {object} object with current browser window width, watching resize of window
 */
const useWindowDimensions = () => {
  const hasWindow = typeof window !== "undefined";
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    return {
      width,
    };
  }

  const [dimensions, setDimensions] = useState(getWindowDimensions());

  const setWindowWidth = () => setDimensions(getWindowDimensions());

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener("resize", debounce(setWindowWidth, 150));
      return () => window.removeEventListener("resize", debounce(setWindowWidth, 150));
    }
  }, []);

  return dimensions;
};

export default useWindowDimensions;
